<template>
	<svg
		id="Calque_1"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		x="0px"
		y="0px"
		viewBox="0 0 250 250"
	>
		<g id="surface25963">
			<path
				v-bind="$attrs"
				class="fill-primary dark:fill-white"
				d="M65.1,31.8c-5.1,0.6-8.8,4.9-8.7,10v166.6c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0
        c3.1-1.8,4.9-5.1,4.9-8.6V41.7c0-2.7-1-5.2-2.9-7.1c-1.9-1.9-4.4-2.9-7.1-2.9C65.7,31.7,65.4,31.7,65.1,31.8z M182.7,31.8
        c-5.1,0.6-8.8,4.9-8.7,10v166.6c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0c3.1-1.8,4.9-5.1,4.9-8.6V41.7c0-2.7-1-5.2-2.9-7.1
        c-1.9-1.9-4.4-2.9-7.1-2.9C183.3,31.7,183,31.7,182.7,31.8z M35.7,75.9c-5.1,0.6-8.8,4.9-8.7,10v78.4c-0.1,3.5,1.8,6.8,4.9,8.6
        c3,1.8,6.8,1.8,9.9,0c3.1-1.8,4.9-5.1,4.9-8.6V85.8c0-2.7-1-5.2-2.9-7.1c-1.9-1.9-4.4-2.9-7.1-2.9C36.3,75.8,36,75.8,35.7,75.9z
        M212.1,75.9c-5.1,0.6-8.8,4.9-8.7,10v78.4c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0c3.1-1.8,4.9-5.1,4.9-8.6V85.8
        c0-2.7-1-5.2-2.9-7.1c-1.9-1.9-4.4-2.9-7.1-2.9C212.7,75.8,212.4,75.8,212.1,75.9z M94.5,80.8c-5.1,0.6-8.8,4.9-8.7,10v68.6
        c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0c3.1-1.8,4.9-5.1,4.9-8.6V90.7c0-2.7-1-5.2-2.9-7.1c-1.9-1.9-4.4-2.9-7.1-2.9
        C95.1,80.7,94.8,80.7,94.5,80.8z M153.3,80.8c-5.1,0.6-8.8,4.9-8.7,10v68.6c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0
        c3.1-1.8,4.9-5.1,4.9-8.6V90.7c0-2.7-1-5.2-2.9-7.1s-4.4-2.9-7.1-2.9C153.9,80.7,153.6,80.7,153.3,80.8z M6.9,105.3
        c-0.2,0-0.4,0.1-0.6,0.2c-2.3,0.5-3.9,2.6-3.8,4.9v29.4c0,1.8,0.9,3.4,2.4,4.3c1.5,0.9,3.4,0.9,4.9,0c1.5-0.9,2.4-2.5,2.4-4.3
        v-29.4c0.1-1.4-0.5-2.8-1.5-3.7C9.7,105.6,8.3,105.1,6.9,105.3z M123.9,105.3c-5.1,0.6-8.8,4.9-8.7,10v19.6
        c-0.1,3.5,1.8,6.8,4.9,8.6c3,1.8,6.8,1.8,9.9,0c3.1-1.8,4.9-5.1,4.9-8.6v-19.6c0-2.7-1-5.2-2.9-7.1c-1.9-1.9-4.4-2.9-7.1-2.9
        C124.5,105.2,124.2,105.2,123.9,105.3z M242.1,105.3c-0.2,0-0.4,0.1-0.6,0.2c-2.3,0.5-3.9,2.6-3.8,4.9v29.4c0,1.8,0.9,3.4,2.4,4.3
        c1.5,0.9,3.4,0.9,4.9,0c1.5-0.9,2.4-2.5,2.4-4.3v-29.4c0.1-1.4-0.5-2.8-1.5-3.7C244.9,105.6,243.5,105.1,242.1,105.3z"
			/>
		</g>
	</svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	inheritAttrs: false,
	name: "LogoSVG",
	setup() {
		return {};
	},
});
</script>
